import React, { useEffect, useState } from "react";
import moment from "moment";
import Loading from "../Common/Loading";
import SideModal from "./SideModal";
import AddBulkicon from "../assets/AddBulkicon.png";
import { API } from "../Common/Api";
import { ErrorToast } from "../Utils/toast";

// Shows a single dealer's agents with each agent's assigned & activated counts.
const DealerAgentsModal = ({ dealer, onClose, setModalOpen }) => {
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    let active = true;
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const res = await API.GetDealerAgents({ dealerId: dealer?._id });
        if (!active) return;
        setAgents(Array.isArray(res?.data?.agents) ? res.data.agents : []);
      } catch (e) {
        if (active) {
          setAgents([]);
          ErrorToast("Failed to fetch agents for this dealer");
        }
      } finally {
        if (active) setLoading(false);
      }
    };
    if (dealer?._id) fetchAgents();
    return () => { active = false; };
  }, [dealer?._id]);

  return (
    <SideModal
      title={`Agents of ${dealer?.username || "Dealer"}`}
      image={AddBulkicon}
      onClose={onClose}
      setModalOpen={setModalOpen}
      width="800px"
    >
      <div className="mt-4 overflow-x-auto relative min-h-[300px]">
        <Loading loading={loading} overlay="table" />
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Agent Name</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Mobile Number</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Email</th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Status</th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Assigned</th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Activated</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">Created At</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {agents.length > 0 ? (
              agents.map((agent) => (
                <tr key={agent._id}>
                  <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{agent.username}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{agent.mobileNo}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{agent.email || "-"}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-center">
                    {agent.isActive ? (
                      <span className="px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900">Active</span>
                    ) : (
                      <span className="px-2 py-[2px] rounded-full text-xs font-medium bg-yellow-100 text-yellow-900">Inactive</span>
                    )}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-500">{agent.assignedCount || 0}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-center text-gray-500">{agent.activatedCount || 0}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                    {agent.createdAt ? moment(agent.createdAt).format("DD MMM, YYYY hh:mm A") : "-"}
                  </td>
                </tr>
              ))
            ) : (
              !loading && (
                <tr>
                  <td colSpan="7" className="px-4 py-4 text-center text-sm text-gray-500">
                    No agents found for this dealer
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </SideModal>
  );
};

export default DealerAgentsModal;
